import { render, staticRenderFns } from "./AuthRegisterPhysicianForm.vue?vue&type=template&id=471be567"
import script from "./AuthRegisterPhysicianForm.vue?vue&type=script&lang=js"
export * from "./AuthRegisterPhysicianForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports